import { ROAMING_PARTNER } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { RoamingPartnerRequestModel } from "./model/RoamingPartnerRequestModel";
import { RoamingPartnerResponseModel } from "./model/RoamingPartnerResponseModel";
import { CreateRoamingPartnerRequestModel } from "./model/create/CreateRoamingPartnerRequestModel";
import { RoamingPartnerDetailResponseModel } from "./model/detail/RoamingPartnerDetailResponseModel";
import { UpdateRoamingPartnerRequestModel } from "./model/update/UpdateRoamingPartnerRequestModel";

export interface IRoamingPartnerRepository {
  getList(
    params: RoamingPartnerRequestModel
  ): Promise<BaseApiResponseModel<RoamingPartnerResponseModel[]>>;
  getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<RoamingPartnerDetailResponseModel>>;
  createPartner(
    body: CreateRoamingPartnerRequestModel
  ): Promise<BaseApiResponseModel<RoamingPartnerResponseModel>>;
  updatePartner(
    body: UpdateRoamingPartnerRequestModel
  ): Promise<BaseApiResponseModel<RoamingPartnerResponseModel>>;
  deletePartner(params: {
    id: string;
  }): Promise<BaseApiResponseModel<RoamingPartnerResponseModel>>;
}

@injectable()
export class RoamingPartnerImpl implements IRoamingPartnerRepository {
  async getList(
    params: RoamingPartnerRequestModel
  ): Promise<BaseApiResponseModel<RoamingPartnerResponseModel[]>> {
    return await client?.get(ROAMING_PARTNER.LIST, params);
  }

  async getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<RoamingPartnerDetailResponseModel>> {
    return await client?.get(ROAMING_PARTNER.DETAIL, params);
  }

  async updatePartner(
    body: UpdateRoamingPartnerRequestModel
  ): Promise<BaseApiResponseModel<RoamingPartnerResponseModel>> {
    return await client?.put(ROAMING_PARTNER.UPDATE, body);
  }

  async createPartner(
    body: CreateRoamingPartnerRequestModel
  ): Promise<BaseApiResponseModel<RoamingPartnerResponseModel>> {
    return await client?.post(ROAMING_PARTNER.CREATE, body);
  }

  async deletePartner(params: {
    id: string;
  }): Promise<BaseApiResponseModel<RoamingPartnerResponseModel>> {
    return await client?.delete(ROAMING_PARTNER.DELETE, params);
  }
}
